import Layout from "../../components/Layout";
import {Link, useNavigate} from "react-router-dom";
import SearchBox from "../../components/SearchBox";
import Pagination from "../../components/Pagination";
import EmployeesTable from "../../components/Tables/EmployeesTable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter} from "@fortawesome/free-solid-svg-icons";
import FilterBox from "../../components/FilterBox";
import {useEffect, useState} from "react";
import ApiRoute, {shopId} from "../../helper/api";
import FilterOrder from "../../components/Order/FilterOrder";
import FilterTabEmployee from "../../components/Employee/FilterTabEmployee";

function Employees() {
    const navigate = useNavigate()
    const [createModal, setCreateModal] = useState(false)

    const [isLoading, setIsLoading] = useState(true)
    const [updateData, setUpdateData] = useState('0')
    const [pageNumber, setPageNumber] = useState(1)
    const [data, setData] = useState({})
    const [searchQuery, setSearchQuery] = useState({
        term: '',
        by: 'title'
    })
    const [filterQuery, setFilterQuery] = useState({
        shop_id: shopId(),
    })

    // state tab for filtering
    const [statsTab , setStatsTab] = useState(null)
    const [selectedStatsTab , setSelectedStatsTab] = useState('')

    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            const  res  = await ApiRoute.employee.index.fn({
                page : pageNumber
            },filterQuery)
            setData(res)
            setIsLoading(false)
        })();
    }, [updateData]);

    const paginationData = data?.results
    const tableData = data?.results?.data ?? []

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [pageNumber]);
    // watch searchQuery and update updateData state
    useEffect(() => {
        filterQuery.quick_search = searchQuery
        setUpdateData(Date.now().toString())
    }, [searchQuery]);
    return (
        <Layout>
            <div>
                <div className="flex items-center justify-between mb-3">
                    <div className="page-title flex-auto ml-3 md:ml-0">
                        <span className="inline-block bg-white pl-3">کارمندان</span>
                    </div>
                    <Link className="btn-blue text-center md:hidden" to="/employees/new"> افزودن کارمند جدید</Link>
                </div>

                <div className="grid md:flex justify-between items-center gap-3">
                    <div className="flex gap-3">
                        <SearchBox SetSearchQuery={setSearchQuery}/>
                    </div>
                    <Link className="btn-blue text-center hidden md:block" to="/employees/new">افزودن کارمند جدید</Link>
                </div>

                <FilterTabEmployee setSelectedTab={ (s) => {
                    filterQuery.shop_id = s
                    setUpdateData(Date.now().toString())
                } }/>

                <div className="main-content p-1 mt-3">
                    {data && <EmployeesTable onDelete={() => {
                        setUpdateData(Date.now().toString())
                    }} tableData={tableData} />}
                    {data && <Pagination Data={paginationData} SetPageNumber={setPageNumber}/>}
                </div>

            </div>
        </Layout>
    )
}

export default Employees